import {
  converge,
  add,
  min,
  call,
  identity,
  pipe,
  prop,
  map,
  unless,
  propEq
} from 'ramda'

// a guestimate of how many bytes we can pretend to upload every second
const bytesPerSecond = 2097152 // 2 MB

const setFileProgress = progress => file => {
  file.progress = progress
  return file
}

/**
 * Creates a progress counter
 * that increments the `progress` property
 * by a percentage of the file size
 * when `increment` is called
 *
 * @param {number} interval - the interval that the progress will be calculated for
 * @returns {{ increment, reset, complete }}
 */
function createProgress (interval) {
  /*
 * Calculates the amount by which we need to increment pretend-progress by
 * @param {number} size - the file size
 * @returns {number} a percentage
 */
  const getIncPercentage = size =>
    100 / (size / (bytesPerSecond / (1000 / interval)))

  const incPercentage = pipe(prop('size'), getIncPercentage)
  const totalProgress = converge(add, [prop('progress'), incPercentage])
  const roundedProgress = pipe(totalProgress, Math.ceil, min(99))
  const setProgress = pipe(roundedProgress, setFileProgress)
  const updateProgress = converge(call, [setProgress, identity])

  const unlessComplete = unless(propEq('progress', 100))

  const increment = map(unlessComplete(updateProgress))
  const reset = map(unlessComplete(setFileProgress(0)))
  const complete = map(unlessComplete(setFileProgress(100)))

  return {
    increment: increment,
    reset,
    complete
  }
}

export default createProgress



// WEBPACK FOOTER //
// ./src/pages/widgets/form/media-upload/progress.js